'use strict'

export function groupUserClaims (claims) {
  function findClaim (claim) {
    return Boolean(claims.find(item => item === claim))
  }

  return {
    menu: {
      ROLE_MENU_EMPLOYEES: findClaim('ROLE_MENU_EMPLOYEES'),
      ROLE_MENU_COMPANY: findClaim('ROLE_MENU_COMPANY'),
      ROLE_MENU_COSTCENTER: findClaim('ROLE_MENU_COSTCENTER'),
      ROLE_MENU_PROJECTS: findClaim('ROLE_MENU_PROJECTS'),
      ROLE_MENU_USAGEPOLICIES: findClaim('ROLE_MENU_USAGEPOLICIES'),
      ROLE_MENU_CREDITPOLICIES: findClaim('ROLE_MENU_CREDITPOLICIES'),
      ROLE_MENU_REPORTS: findClaim('ROLE_MENU_REPORTS'),
      ROLE_MENU_FINANCIAL: findClaim('ROLE_MENU_FINANCIAL'),
      ROLE_MENU_USERS: findClaim('ROLE_MENU_USERS'),
      ROLE_MENU_FINANCIAL_ADJUSTMENT: findClaim('ROLE_MENU_FINANCIAL_ADJUSTMENT'),
      ROLE_MENU_CELPHONE_SEARCH: findClaim('ROLE_MENU_CELPHONE_SEARCH')
    },
    profiles: {
      ROLE_ADMINISTRATOR: findClaim('ROLE_ADMINISTRATOR'),
      ROLE_FINANCIAL_ADMIN: findClaim('ROLE_FINANCIAL_ADMIN'),
      ROLE_REPORT_ADMIN: findClaim('ROLE_REPORT_ADMIN'),
      ROLE_CORPORATE_USER: findClaim('ROLE_CORPORATE_USER'),
      ROLE_OWNER_USER: findClaim('ROLE_OWNER_USER'),
      ROLE_FINANCIAL_USER: findClaim('ROLE_FINANCIAL_USER'),
      ROLE_REPORT_USER: findClaim('ROLE_REPORT_USER'),
      ROLE_SUPERVISOR_USER: findClaim('ROLE_SUPERVISOR_USER'),
      ROLE_EMPLOYEE_USER: findClaim('ROLE_EMPLOYEE_USER'),
      ROLE_ANY_USER: findClaim('ROLE_ANY_USER')
    },
    path: {
      ROLE_OPTIONS_PATH: findClaim('ROLE_OPTIONS_PATH')
    },
    user: {
      ROLE_POST_LOGIN: findClaim('ROLE_POST_LOGIN'),
      ROLE_GET_LOGIN: findClaim('ROLE_GET_LOGIN'),
      ROLE_GET_LOGOUT: findClaim('ROLE_GET_LOGOUT'),
      ROLE_POST_FORGOTPASSWORD: findClaim('ROLE_POST_FORGOTPASSWORD'),
      ROLE_LIST_INTERNAL_USERS: findClaim('ROLE_LIST_INTERNAL_USERS'),
      ROLE_GET_INTERNAL_USERS: findClaim('ROLE_GET_INTERNAL_USERS'),
      ROLE_POST_INTERNAL_USERS: findClaim('ROLE_POST_INTERNAL_USERS'),
      ROLE_PUT_INTERNAL_USERS: findClaim('ROLE_PUT_INTERNAL_USERS'),
      ROLE_DELETE_INTERNAL_USERS: findClaim('ROLE_DELETE_INTERNAL_USERS'),
      ROLE_POST_VERIFY_METHOD: findClaim('ROLE_POST_VERIFY_METHOD')
    },
    corporateAccount: {
      ROLE_PUT_SETCORPORATEACCOUNTPASSWORD: findClaim('ROLE_PUT_SETCORPORATEACCOUNTPASSWORD'),
      ROLE_GET_CORPORATEACCOUNT_ID_FORGOTPASSWORD: findClaim(
        'ROLE_GET_CORPORATEACCOUNT_ID_FORGOTPASSWORD'
      )
    },
    company: {
      ROLE_GET_COMPANY: findClaim('ROLE_GET_COMPANY'),
      ROLE_POST_COMPANY: findClaim('ROLE_POST_COMPANY'),
      ROLE_GET_COMPANY_FINANCIALCONFIG: findClaim('ROLE_GET_COMPANY_FINANCIALCONFIG'),
      ROLE_GET_COMPANY_ID: findClaim('ROLE_GET_COMPANY_ID'),
      ROLE_GET_COMPANY_ID_CONFIG: findClaim('ROLE_GET_COMPANY_ID_CONFIG'),
      ROLE_PUT_COMPANY_ID_CONFIG: findClaim('ROLE_PUT_COMPANY_ID_CONFIG'),
      ROLE_PUT_COMPANY_ID_ENABLE: findClaim('ROLE_PUT_COMPANY_ID_ENABLE'),
      ROLE_PUT_COMPANY_ID_DISABLE: findClaim('ROLE_PUT_COMPANY_ID_DISABLE'),
      ROLE_PUT_COMPANY_ID_ADDALLCOSTCENTERSTOALLEMPLOYEES: findClaim(
        'ROLE_PUT_COMPANY_ID_ADDALLCOSTCENTERSTOALLEMPLOYEES'
      ),
      ROLE_PUT_COMPANY_ID_DELETEALLCOSTCENTERS: findClaim(
        'ROLE_PUT_COMPANY_ID_DELETEALLCOSTCENTERS'
      ),
      ROLE_GET_COMPANY_ID_ACCOUNTS: findClaim('ROLE_GET_COMPANY_ID_ACCOUNTS'),
      ROLE_POST_COMPANY_RENOTIFY: findClaim('ROLE_POST_COMPANY_RENOTIFY'),
      ROLE_PUT_COMPANY_ENABLEALLEMPLOYEE_V2PERMISSION: findClaim(
        'ROLE_PUT_COMPANY_ENABLEALLEMPLOYEE_V2PERMISSION'
      ),
      ROLE_GET_COMPANY_ID_FINANCIALCONFIG: findClaim('ROLE_GET_COMPANY_ID_FINANCIALCONFIG'),
      ROLE_PUT_COMPANY_ID_FINANCIALCONFIG: findClaim('ROLE_PUT_COMPANY_ID_FINANCIALCONFIG'),
      ROLE_POST_COMPANY_ID_COSTCENTER_UPLOAD: findClaim('ROLE_POST_COMPANY_ID_COSTCENTER_UPLOAD'),
      ROLE_GET_COMPANY_ID_COSTCENTER_UPLOAD: findClaim('ROLE_GET_COMPANY_ID_COSTCENTER_UPLOAD'),
      ROLE_POST_COMPANY_ID_EMPLOYEE_UPLOAD: findClaim('ROLE_POST_COMPANY_ID_EMPLOYEE_UPLOAD'),
      ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE: findClaim(
        'ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE'
      ),
      ROLE_POST_COMPANY_COMPANYID_BULKOPERATION_ID_EXECUTE: findClaim(
        'ROLE_POST_COMPANY_COMPANYID_BULKOPERATION_ID_EXECUTE'
      ),
      ROLE_GET_COMPANY_COMPANYID_BULKOPERATION: findClaim(
        'ROLE_GET_COMPANY_COMPANYID_BULKOPERATION'
      ),
      ROLE_DELETE_COMPANY_ID_COSTCENTERS: findClaim('ROLE_DELETE_COMPANY_ID_COSTCENTERS'),
      ROLE_DELETE_COMPANY_ID_EMPLOYEES: findClaim('ROLE_DELETE_COMPANY_ID_EMPLOYEES'),
      ROLE_DELETE_COMPANY_COMPANYID_PROJECT_MULTIDELETE: findClaim(
        'ROLE_DELETE_COMPANY_COMPANYID_PROJECT_MULTIDELETE'
      ),
      ROLE_POST_COMPANY_ID_PROJECT_UPLOAD: findClaim('ROLE_POST_COMPANY_ID_PROJECT_UPLOAD'),
      ROLE_PUT_COMPANY_ID_PHONE: findClaim('ROLE_PUT_COMPANY_ID_PHONE'),
      ROLE_DELETE_COMPANY_COMPANYID_EMPLOYEES_MULTIDELETE: findClaim(
        'ROLE_DELETE_COMPANY_COMPANYID_EMPLOYEES_MULTIDELETE'
      ),
      ROLE_PUT_COMPANY_ID_ALLOWWEBCALL: findClaim('ROLE_PUT_COMPANY_ID_ALLOWWEBCALL'),
      ROLE_GET_TOKEN_LIST: findClaim('ROLE_GET_TOKEN_LIST')
    },
    companyGroup: {
      ROLE_POST_COMPANYGROUP: findClaim('ROLE_POST_COMPANYGROUP'),
      ROLE_GET_COMPANYGROUP: findClaim('ROLE_GET_COMPANYGROUP'),
      ROLE_PUT_COMPANYGROUP: findClaim('ROLE_PUT_COMPANYGROUP'),
      ROLE_DELETE_COMPANYGROUP: findClaim('ROLE_DELETE_COMPANYGROUP')
    },
    anonymization: {
      ROLE_POST_LGPD_ANONYMIZATION_REQUEST: findClaim('ROLE_POST_LGPD_ANONYMIZATION_REQUEST'),
      ROLE_GET_LGPD_ANONYMIZATION_REQUEST: findClaim('ROLE_GET_LGPD_ANONYMIZATION_REQUEST'),
      ROLE_PATCH_LGPD_ANONYMIZATION_CONFIRM: findClaim('ROLE_PATCH_LGPD_ANONYMIZATION_CONFIRM'),
      ROLE_DELETE_LGPD_ANONYMIZATION: findClaim('ROLE_DELETE_LGPD_ANONYMIZATION')
    },
    timePolicy: {
      ROLE_GET_TIMEPOLICY: findClaim('ROLE_GET_TIMEPOLICY'),
      ROLE_POST_TIMEPOLICY: findClaim('ROLE_POST_TIMEPOLICY'),
      ROLE_GET_TIMEPOLICY_BYPASS: findClaim('ROLE_GET_TIMEPOLICY_BYPASS'),
      ROLE_POST_TIMEPOLICY_BYPASS: findClaim('ROLE_POST_TIMEPOLICY_BYPASS'),
      ROLE_DELETE_TIMEPOLICY_BYPASS_EMPLOYEEID: findClaim(
        'ROLE_DELETE_TIMEPOLICY_BYPASS_EMPLOYEEID'
      ),
      ROLE_GET_TIMEPOLICY_TIMEPOLICYID: findClaim('ROLE_GET_TIMEPOLICY_TIMEPOLICYID'),
      ROLE_PUT_TIMEPOLICY_TIMEPOLICYID: findClaim('ROLE_PUT_TIMEPOLICY_TIMEPOLICYID'),
      ROLE_DELETE_TIMEPOLICY_TIMEPOLICYID: findClaim('ROLE_DELETE_TIMEPOLICY_TIMEPOLICYID'),
      ROLE_GET_TIMEPOLICY_TIMEPOLICYID_COSTCENTER: findClaim(
        'ROLE_GET_TIMEPOLICY_TIMEPOLICYID_COSTCENTER'
      ),
      ROLE_PUT_TIMEPOLICY_TIMEPOLICYID_COSTCENTER: findClaim(
        'ROLE_PUT_TIMEPOLICY_TIMEPOLICYID_COSTCENTER'
      ),
      ROLE_DELETE_TIMEPOLICY_TIMEPOLICYID_COSTCENTER_CCID: findClaim(
        'ROLE_DELETE_TIMEPOLICY_TIMEPOLICYID_COSTCENTER_CCID'
      )
    },
    employee: {
      ROLE_GET_EMPLOYEE: findClaim('ROLE_GET_EMPLOYEE'),
      ROLE_POST_EMPLOYEE: findClaim('ROLE_POST_EMPLOYEE'),
      ROLE_GET_EMPLOYEE_EXPORT: findClaim('ROLE_GET_EMPLOYEE_EXPORT'),
      ROLE_PUT_EMPLOYEE_BATCHCATEGORIES: findClaim('ROLE_PUT_EMPLOYEE_BATCHCATEGORIES'),
      ROLE_GET_EMPLOYEE_RIDECREDIT: findClaim('ROLE_GET_EMPLOYEE_RIDECREDIT'),
      ROLE_GET_EMPLOYEE_PENDING: findClaim('ROLE_GET_EMPLOYEE_PENDING'),
      ROLE_POST_EMPLOYEE_BULKACTIVATE: findClaim('ROLE_POST_EMPLOYEE_BULKACTIVATE'),
      ROLE_GET_EMPLOYEE_ID: findClaim('ROLE_GET_EMPLOYEE_ID'),
      ROLE_DELETE_EMPLOYEE_ID: findClaim('ROLE_DELETE_EMPLOYEE_ID'),
      ROLE_PUT_EMPLOYEE_ID: findClaim('ROLE_PUT_EMPLOYEE_ID'),
      ROLE_GET_EMPLOYEE_ID_COSTCENTERS: findClaim('ROLE_GET_EMPLOYEE_ID_COSTCENTERS'),
      ROLE_GET_EMPLOYEE_ID_OWNCOSTCENTER: findClaim('ROLE_GET_EMPLOYEE_ID_OWNCOSTCENTER'),
      ROLE_POST_EMPLOYEE_ID_RESENDWELCOMEEMAIL: findClaim(
        'ROLE_POST_EMPLOYEE_ID_RESENDWELCOMEEMAIL'
      ),
      ROLE_GET_EMPLOYEE_ID_RIDECREDIT: findClaim('ROLE_GET_EMPLOYEE_ID_RIDECREDIT'),
      ROLE_POST_EMPLOYEE_ID_RIDECREDIT: findClaim('ROLE_POST_EMPLOYEE_ID_RIDECREDIT'),
      ROLE_PUT_EMPLOYEE_ID_RIDECREDIT: findClaim('ROLE_PUT_EMPLOYEE_ID_RIDECREDIT'),
      ROLE_DELETE_EMPLOYEE_ID_RIDECREDIT: findClaim('ROLE_DELETE_EMPLOYEE_ID_RIDECREDIT'),
      ROLE_PUT_EMPLOYEE_ID_ADDTOALLCOSTCENTERS: findClaim(
        'ROLE_PUT_EMPLOYEE_ID_ADDTOALLCOSTCENTERS'
      ),
      ROLE_POST_EMPLOYEE_RENOTIFY: findClaim('ROLE_POST_EMPLOYEE_RENOTIFY'),
      ROLE_GET_EMPLOYEE_PHONE_PHONE: findClaim('ROLE_GET_EMPLOYEE_PHONE_PHONE'),
      ROLE_EMPLOYEE_WIZARD: findClaim('ROLE_EMPLOYEE_WIZARD'),
      ROLE_EMPLOYEE_WIZARD_PHONE_NUMBERS: findClaim('ROLE_EMPLOYEE_WIZARD_PHONE_NUMBERS'),
      ROLE_GET_EMPLOYEE_PHONE_VERIFY: findClaim('ROLE_GET_EMPLOYEE_PHONE_VERIFY')
    },
    costCenter: {
      ROLE_GET_COSTCENTER: findClaim('ROLE_GET_COSTCENTER'),
      ROLE_POST_COSTCENTER: findClaim('ROLE_POST_COSTCENTER'),
      ROLE_GET_COSTCENTER_EXPORT: findClaim('ROLE_GET_COSTCENTER_EXPORT'),
      ROLE_GET_COSTCENTER_ID: findClaim('ROLE_GET_COSTCENTER_ID'),
      ROLE_PUT_COSTCENTER_ID: findClaim('ROLE_PUT_COSTCENTER_ID'),
      ROLE_DELETE_COSTCENTER_ID: findClaim('ROLE_DELETE_COSTCENTER_ID'),
      ROLE_PUT_COSTCENTER_ID_ADDTOALLEMPLOYEES: findClaim(
        'ROLE_PUT_COSTCENTER_ID_ADDTOALLEMPLOYEES'
      )
    },
    project: {
      ROLE_GET_PROJECT: findClaim('ROLE_GET_PROJECT'),
      ROLE_POST_PROJECT: findClaim('ROLE_POST_PROJECT'),
      ROLE_GET_PROJECT_EXPORT: findClaim('ROLE_GET_PROJECT_EXPORT'),
      ROLE_GET_PROJECT_ID: findClaim('ROLE_GET_PROJECT_ID'),
      ROLE_PUT_PROJECT_ID: findClaim('ROLE_PUT_PROJECT_ID'),
      ROLE_DELETE_PROJECT_ID: findClaim('ROLE_DELETE_PROJECT_ID')
    },
    report: {
      ROLE_GET_REPORT_COSTCENTER: findClaim('ROLE_GET_REPORT_COSTCENTER'),
      ROLE_GET_REPORT_COSTCENTER_EXPORT_VALIDATE: findClaim(
        'ROLE_GET_REPORT_COSTCENTER_EXPORT_VALIDATE'
      ),
      ROLE_GET_REPORT_COSTCENTER_BUDGET: findClaim('ROLE_GET_REPORT_COSTCENTER_BUDGET'),
      ROLE_GET_REPORT_COSTCENTER_BUDGET_EXPORT: findClaim(
        'ROLE_GET_REPORT_COSTCENTER_BUDGET_EXPORT'
      ),
      ROLE_GET_REPORT_CHART: findClaim('ROLE_GET_REPORT_CHART'),
      ROLE_GET_REPORT_EMPLOYEE: findClaim('ROLE_GET_REPORT_EMPLOYEE'),
      ROLE_GET_REPORT_EMPLOYEE_EXPORT_VALIDATE: findClaim(
        'ROLE_GET_REPORT_EMPLOYEE_EXPORT_VALIDATE'
      ),
      ROLE_GET_REPORT_TAXIJOBS: findClaim('ROLE_GET_REPORT_TAXIJOBS'),
      ROLE_GET_REPORT_TAXIJOBS_EXPORT_VALIDATE: findClaim(
        'ROLE_GET_REPORT_TAXIJOBS_EXPORT_VALIDATE'
      ),
      ROLE_GET_REPORTS_ID: findClaim('ROLE_GET_REPORTS_ID'),
      ROLE_GET_REPORT_RECEIPT: findClaim('ROLE_GET_REPORT_RECEIPT'),
      ROLE_POST_REPORT_TAXIJOBS_SCHEDULE: findClaim('ROLE_POST_REPORT_TAXIJOBS_SCHEDULE'),
      ROLE_GET_REPORT_TAXIJOBS_ACTIVES: findClaim('ROLE_GET_REPORT_TAXIJOBS_ACTIVES'),
      ROLE_GET_REPORT_TAXIJOBS_DOWNLOAD: findClaim('ROLE_GET_REPORT_TAXIJOBS_DOWNLOAD')
    },
    financial: {
      ROLE_GET_REFUND_REPORT: findClaim('ROLE_GET_REFUND_REPORT'),
      ROLE_GET_SERVICE_REPORT: findClaim('ROLE_GET_SERVICE_REPORT'),
      ROLE_GET_REFUNDS: findClaim('ROLE_GET_REFUNDS'),
      ROLE_GET_REFUNDSPAYMENTS: findClaim('ROLE_GET_REFUNDSPAYMENTS'),
      ROLE_GET_REFUND_ID_RECEIPTS: findClaim('ROLE_GET_REFUND_ID_RECEIPTS'),
      ROLE_POST_REFUNDS_DISCOUNT: findClaim('ROLE_POST_REFUNDS_DISCOUNT'),
      ROLE_POST_REFUNDS_DISCOUNT_CSV: findClaim('ROLE_POST_REFUNDS_DISCOUNT_CSV'),
      ROLE_GET_COMPANY_COMPANYID_CREDITCARD: findClaim('ROLE_GET_COMPANY_COMPANYID_CREDITCARD'),
      ROLE_DELETE_CREDITCARD_CREDITCARDID: findClaim('ROLE_DELETE_CREDITCARD_CREDITCARDID'),
      ROLE_GET_CREDITCARD_ACCOUNTID: findClaim('ROLE_GET_CREDITCARD_ACCOUNTID'),
      ROLE_POST_CREDITCARD: findClaim('ROLE_POST_CREDITCARD'),
      ROLE_POST_CHANGE_PAYMENTMETHOD: findClaim('ROLE_POST_CHANGE_PAYMENTMETHOD'),
      ROLE_GET_REFUND_BREAKDOWN: findClaim('ROLE_GET_REFUND_BREAKDOWN'),
      ROLE_GET_ORDER_REPROCESS: findClaim('ROLE_GET_ORDER_REPROCESS'),
      ROLE_PUT_ORDER_REPROCESS_PERIOD: findClaim('ROLE_PUT_ORDER_REPROCESS_PERIOD'),
      ROLE_PUT_ORDER_REPROCESS_MASSIVE: findClaim('ROLE_PUT_ORDER_REPROCESS_MASSIVE'),
      ROLE_POST_ORDER_UPLOAD_NFE: findClaim('ROLE_POST_ORDER_UPLOAD_NFE'),
      ROLE_GET_FINANCE_SUMMARY: findClaim('ROLE_GET_FINANCE_SUMMARY'),
      ROLE_GET_ORDER_DOCUMENTS_URL: findClaim('ROLE_GET_ORDER_DOCUMENTS_URL')
    },
    webCall: {
      ROLE_GET_WEBCALL_COMPANY: findClaim('ROLE_GET_WEBCALL_COMPANY'),
      ROLE_GET_WEBCALL_EMPLOYEE: findClaim('ROLE_GET_WEBCALL_EMPLOYEE'),
      ROLE_GET_WEBCALL_EMPLOYEE_ID_CATEGORY: findClaim('ROLE_GET_WEBCALL_EMPLOYEE_ID_CATEGORY'),
      ROLE_GET_WEBCALL_EMPLOYEE_ID_COSTCENTERS: findClaim(
        'ROLE_GET_WEBCALL_EMPLOYEE_ID_COSTCENTERS'
      ),
      ROLE_POST_WEBCALL: findClaim('ROLE_POST_WEBCALL'),
      ROLE_PUT_WEBCALL_CALLID_CANCEL: findClaim('ROLE_PUT_WEBCALL_CALLID_CANCEL'),
      ROLE_DELETE_WEBCALL_CALLID_DISMISS: findClaim('ROLE_DELETE_WEBCALL_CALLID_DISMISS'),
      ROLE_GET_WEBCALL: findClaim('ROLE_GET_WEBCALL'),
      ROLE_GET_WEBCALL_CANUSE: findClaim('ROLE_GET_WEBCALL_CANUSE'),
      ROLE_GET_WEBCALL_CALLID: findClaim('ROLE_GET_WEBCALL_CALLID')
    },
    asyncjob: {
      ROLE_GET_ASYNCJOB_KEY: findClaim('ROLE_GET_ASYNCJOB_KEY')
    },
    custom: {
      POP_99: findClaim('POP_99'),
      TURBO_TAXI: findClaim('TURBO_TAXI'),
      REGULAR_TAXI: findClaim('REGULAR_TAXI'),
      TOP_99: findClaim('TOP_99'),
      V2_PERMISSION: findClaim('V2_PERMISSION'),
      WEBCALL_PERMISSION: findClaim('WEBCALL_PERMISSION'),
      THIRDPARTY_WEBCALL_PERMISSION: findClaim('THIRDPARTY_WEBCALL_PERMISSION'),
      OWN_COST_CENTER: findClaim('OWN_COST_CENTER'),
      ROLE_POST_PROCESS: findClaim('ROLE_POST_PROCESS'),
      ROLE_POST_REQUEST_API_TOKEN: findClaim('ROLE_POST_REQUEST_API_TOKEN')
    },
    ui: {
      UI_HOME_DASHBOARD: findClaim('UI_HOME_DASHBOARD'),
      UI_ALL_COMPANIES: findClaim('UI_ALL_COMPANIES'),
      UI_VIEW_COUPON_REQUEST: findClaim('UI_VIEW_COUPON_REQUEST'),
      UI_VIEW_DAILY_LIMIT: findClaim('UI_VIEW_DAILY_LIMIT'),
      UI_ENABLED_WATERMARK: findClaim('UI_ENABLED_WATERMARK'),
      UI_DISABLE_COPY: findClaim('UI_DISABLE_COPY')
    },
    billing: {
      ROLE_GET_ORDER_PREVIEW_SUMMARY: findClaim('ROLE_GET_ORDER_PREVIEW_SUMMARY'),
      ROLE_GET_ORDERS: findClaim('ROLE_GET_ORDERS'),
      ROLE_GET_ORDER_SUMMARY: findClaim('ROLE_GET_ORDER_SUMMARY'),
      ROLE_GET_FINANCIAL_ACCOUNT_PAYMENT_METHOD: findClaim(
        'ROLE_GET_FINANCIAL_ACCOUNT_PAYMENT_METHOD'
      ),
      ROLE_PUT_CREDIT_CARD: findClaim('ROLE_PUT_CREDIT_CARD'),
      ROLE_GET_ORDER_PREVIEW_RIDE_SERVICE_RECEIPTS: findClaim(
        'ROLE_GET_ORDER_PREVIEW_RIDE_SERVICE_RECEIPTS'
      ),
      ROLE_GET_ORDER_SERVICE_RECEIPTS: findClaim('ROLE_GET_ORDER_SERVICE_RECEIPTS'),
      ROLE_GET_FINANCIAL_CONFIG: findClaim('ROLE_GET_FINANCIAL_CONFIG'),
      ROLE_GET_DISCOUNT_BY_COMPANY_ID: findClaim('ROLE_GET_DISCOUNT_BY_COMPANY_ID'),
      ROLE_POST_CREATE_OR_UPDATE_DISCOUNT: findClaim('ROLE_POST_CREATE_OR_UPDATE_DISCOUNT'),
      ROLE_GET_ORDER_SUMMARY_UPDATED: findClaim('ROLE_GET_ORDER_SUMMARY_UPDATED'),
      ROLE_POST_DUPLICATE_INVOICE: findClaim('ROLE_POST_DUPLICATE_INVOICE'),
      ROLE_POST_CHARGEBACK: findClaim('ROLE_POST_CHARGEBACK'),
      ROLE_PUT_CHARGEBACK: findClaim('ROLE_PUT_CHARGEBACK'),
      ROLE_PUT_DENY_CHARGEBACK: findClaim('ROLE_PUT_DENY_CHARGEBACK'),
      ROLE_DELETE_CHARGEBACK: findClaim('ROLE_DELETE_CHARGEBACK'),
      ROLE_GET_CHARGEBACK: findClaim('ROLE_GET_CHARGEBACK'),
      ROLE_PUT_UPDATE_CREDIT: findClaim('ROLE_PUT_UPDATE_CREDIT'),
      ROLE_GET_FIND_BY_API_TAXI_JOB_ID: findClaim('ROLE_GET_FIND_BY_API_TAXI_JOB_ID'),
      ROLE_GET_FIND_CREDITS_WITH_BALANCE: findClaim('ROLE_GET_FIND_CREDITS_WITH_BALANCE'),
      ROLE_DELETE_CANCEL_CREDIT: findClaim('ROLE_DELETE_CANCEL_CREDIT'),
      ROLE_POST_CREATE_CREDIT: findClaim('ROLE_POST_CREATE_CREDIT'),
      ROLE_PUT_FINANCIAL_ACCOUNT_EMAILS_TO_NOTIFY: findClaim(
        'ROLE_PUT_FINANCIAL_ACCOUNT_EMAILS_TO_NOTIFY'
      ),
      ROLE_PUT_FINANCIAL_ACCOUNT_PAYMENT_METHOD: findClaim(
        'ROLE_PUT_FINANCIAL_ACCOUNT_PAYMENT_METHOD'
      ),
      ROLE_POST_DUPLICATE_INVOICE_ENABLE_EDIT_DUE_DATE: findClaim(
        'ROLE_POST_DUPLICATE_INVOICE_ENABLE_EDIT_DUE_DATE'
      ),
      ROLE_GET_MASSIVE_ORDER_PAYMENT_STATUS_WORKER: findClaim(
        'ROLE_GET_MASSIVE_ORDER_PAYMENT_STATUS_WORKER'
      ),
      ROLE_POST_RUN_MASSIVE_ORDER_PAYMENT_STATUS_WORKER: findClaim(
        'ROLE_POST_RUN_MASSIVE_ORDER_PAYMENT_STATUS_WORKER'
      ),
      ROLE_POST_UPLOAD_MASSIVE_ORDER_FILE: findClaim('ROLE_POST_UPLOAD_MASSIVE_ORDER_FILE'),
      ROLE_GET_PAGINATED_ORDERS: findClaim('ROLE_GET_PAGINATED_ORDERS'),
      ROLE_PATCH_UPDATE_PAYMENT_STATUS: findClaim('ROLE_PATCH_UPDATE_PAYMENT_STATUS'),
      ROLE_POST_INCENTIVE_UPLOAD: findClaim('ROLE_POST_INCENTIVE_UPLOAD'),
      ROLE_GET_INCENTIVES: findClaim('ROLE_GET_INCENTIVES'),
      ROLE_PATCH_INCENTIVE_PENDING_TO_APPROVAL: findClaim(
        'ROLE_PATCH_INCENTIVE_PENDING_TO_APPROVAL'
      ),
      ROLE_POST_INCENTIVE_APPROVED: findClaim('ROLE_POST_INCENTIVE_APPROVED'),
      ROLE_GET_INCENTIVE_UPLOAD: findClaim('ROLE_GET_INCENTIVE_UPLOAD'),
      ROLE_GET_INCENTIVE_DETAIL: findClaim('ROLE_GET_INCENTIVE_DETAIL'),
      ROLE_GET_FINANCIAL_ACCOUNT_INCENTIVES: findClaim('ROLE_GET_FINANCIAL_ACCOUNT_INCENTIVES')
    },
    coupon: {
      ROLE_CREATE_REQUEST_COUPON: findClaim('ROLE_CREATE_REQUEST_COUPON'),
      ROLE_VALIDATE_SHEET_COUPON: findClaim('ROLE_VALIDATE_SHEET_COUPON')
    }
  }
}
